module.exports = __webpack_public_path__ + "assets/media/3.3bde1336.wav";